import React, { useState } from "react";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../firebase";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
    } catch (error) {
      setError("Invalid email or password. Please try again.");
      console.error("Error during email/password login:", error);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      navigate("/");
    } catch (error) {
      setError("Unable to sign in with Google. Please try again.");
      console.error("Error during Google Sign-In:", error);
    }
  };

  return (
    <div style={styles.container}>
      <img
        src="/logo-real.png"
        alt="Roster Logo"
        style={styles.logo}
      />
      <div style={styles.card}>
        <form onSubmit={handleEmailLogin} style={styles.form}>
          <label htmlFor="email" style={styles.label}>
            Email
          </label>
          <input
            type="email"
            id="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
          />
          <label htmlFor="password" style={styles.label}>
            Password
          </label>
          <input
            type="password"
            id="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
            autoComplete="current-password"
          />
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.signInButton}>
            Sign in
          </button>
        </form>
        <button onClick={handleGoogleLogin} style={styles.googleButton}>
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google Logo"
            style={styles.googleIcon}
          />
          Sign in with Google
        </button>
        <p style={styles.footer}>
          Don't have an account?{" "}
          <span
          onClick={() => {
            console.log("Navigating to Sign-Up...");
            navigate("/signup"); // Ensure this happens regardless of auth state
          }}
          style={styles.link}
        >
          Sign up
        </span>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f7f7f7",
  },
  logo: {
    width: "270px",
    marginBottom: "40px", // Increased the margin to push the form down
  },
  card: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "400px",
  },
  title: {
    fontSize: "24px",
    marginBottom: "20px",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "15px",
  },
  label: {
    marginBottom: "5px",
    fontSize: "14px",
    fontWeight: "500",
  },
  input: {
    padding: "10px",
    borderRadius: "5px",
    border: "1px solid #ddd",
    marginBottom: "15px",
    fontSize: "14px",
    outline: "none",
  },
  error: {
    color: "red",
    fontSize: "14px",
    marginBottom: "15px",
  },
  signInButton: {
    backgroundColor: "#4285F4",
    color: "#fff",
    padding: "10px 15px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    marginBottom: "15px",
  },
  googleButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: "5px",
    padding: "10px",
    cursor: "pointer",
    fontSize: "16px",
    width: "100%", // This ensures the button spans the full width of the container
    maxWidth: "400px", // Keeps it from getting too wide
  },  
  googleIcon: {
    width: "18px",
    height: "18px",
    marginRight: "10px",
  },
  footer: {
    fontSize: "14px",
    textAlign: "center",
    marginTop: "15px",
  },
  link: {
    color: "#4285F4",
    cursor: "pointer",
    textDecoration: "underline",
  },
};


export default Login;
